import store from '../../../../../redux'
import validation from '../../../../elements/ValidationService'
import currencyType from '../../../../elements/CurrecyType'
import { activateSecondScreenAction, validationSecondScreenAction } from '../../../../../redux/stores/firstScreen/action'

const { dispatch } = store

const emailValid = (email) => {
    if (email) {
        if (!validation('EMAIL', email)) {
            return true
        }
    } else {
        return true
    }
}

const outDestinationValid = (state, outDestination) => {
    if (outDestination) {
        if (state.payway === 'MOBILE_PHONE') {
            if (!validation('PHONE_UA', outDestination)) {
                return true
            }
        } else if (state.payway === 'QIWI' && state.exchangeWayType === 'SELL') {
            if (!validation('PHONE_RU', outDestination)) {
                return true
            }
        } else if (state.payway === 'VISA_MC_P2P' && state.exchangeWayType === 'SELL') {
            if (!validation('CARD', outDestination)) {
                return true
            }
        } else {
            if (!validation(currencyType(state.outCurrency), outDestination)) {
                return true
            }
        }
    } else {
        return true
    }
}

const cardValid = (card, payway) => {
    if (payway === 'QIWI') {
        if (!validation('PHONE_RU', card)) {
            return true
        }
        return true
    }

    if (card) {
        if (!validation('CARD', card))
            return true
    } else {
        return true
    }
}

export default async function activateSecondScreenHandler(state, pathUrl) {
    const localEmail = emailValid(state.email) || false
    const localCard = !state.cardData ? state.exchangeWayType === 'BUY' ? true : false : state.cardData.status !== 'SUCCESS' && (state.payway === 'CARD' || state.payway.indexOf('VISA_MC') !== -1) ? true : cardValid(state.cardData.number, state.payway) || false
    const localDestination = outDestinationValid(state, state.outDestination) || false

    if (localDestination || localEmail || localCard) {
        dispatch(validationSecondScreenAction(state, localDestination, localEmail, localCard))
        return true
    }

    const activeExchangeWay = state.allExchangeWays.find(way => way.exchangeWayId === state.equivalentData.exchangeWayId);

    dispatch(activateSecondScreenAction(state, activeExchangeWay.fees, activeExchangeWay.exchangeRate.currencySide))
    pathUrl('pre-check')
}